<style>
.label {
    color: #808CA3;
    font-weight: normal;
    font-size: 70%;
    text-transform: uppercase;
}


</style>

<template>

    <div class="modal fade course-schedules-details" ref="courseScheduleDetailModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-if="courseSchedule">
                        #{{ courseSchedule.id }} {{ courseSchedule.course.name }}
                    </h5>
                    <button type="button" class="btn-close" @click="hide()" aria-label="Close"></button>
                </div>
                <div v-if="viewType === 'show'">
                    <div class="modal-body" v-if="courseSchedule">

                        <div class="row">
                            <div class="col-md-6">
                                <h5>Course Schedule #{{ courseSchedule.id }}</h5>
                                <div class="row mb-3">
                                    <div class="col-md-4 label">Path</div>
                                    <div class="col-md-8">
                                        {{ courseSchedule.path.name }}
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-md-4 label">Status</div>
                                    <div class="col-md-8">
                                        <span v-if="courseSchedule.is_active" class="text-success">active</span>
                                        <span v-else class="text-danger">not active</span>
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-md-4 label app-required">Date</div>
                                    <div class="col-md-8">
                                        {{ dateFormat(courseSchedule.from, 'dddd, D MMM') }}
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-md-4 label app-required">Time</div>
                                    <div class="col-md-8">
                                        from {{ dateFormat(courseSchedule.from, 'h:mm a') }} till
                                        {{ dateFormat(courseSchedule.till, 'h:mm a') }}
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-md-4 label app-required">Class</div>
                                    <div class="col-md-8">
                                        <a target="_blank" :href="courseSchedule.course.link">{{
                                                courseSchedule.course.name
                                            }}</a>
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-md-4 label app-required">Trainer</div>
                                    <div class="col-md-8">
                                <span v-if="courseSchedule.trainer">
                                    <a target="_blank"
                                       :href="courseSchedule.trainer.link">{{ courseSchedule.trainer.name }}</a>
                                </span>
                                        <span v-else>no</span>
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-md-4 label">Level</div>
                                    <div class="col-md-8">
                                        {{ courseSchedule.level.name }}
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-md-4 label">Capacity</div>
                                    <div class="col-md-8">
                                        {{ courseSchedule.capacity }}
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-md-4 label app-required">Location</div>
                                    <div class="col-md-8">
                                        <div v-if="courseSchedule.location">
                                            <a target="_blank" :href="courseSchedule.location.link">{{
                                                    courseSchedule.location.name
                                                }}</a>
                                        </div>
                                        <span
                                            v-if="courseSchedule.location_comment"><em>{{
                                                courseSchedule.location_comment
                                            }}</em></span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <h5>Guests</h5>
                                <div class="table-responsive course-orders" v-if="courseOrders.length > 0" style="max-height: 400px; overflow-y: auto">
                                    <table class="table table-reset">
                                        <thead>
                                        <tr>
                                            <th>booking</th>
                                            <th>path</th>
                                            <th>room</th>
                                            <th>name</th>
                                            <th></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="order in courseOrders" class="course-order">
                                            <td>
                                                <span v-if="order.booking">
                                                    <a v-if="order.booking.link" :href="order.booking.link" target="_blank">{{  order.booking.name }}</a>
                                                    <span v-else>{{  order.booking.name }}</span>
                                                </span>
                                            </td>
                                            <td>{{  order.path }}</td>
                                            <td>{{ getRoomParamForGuest(order.user.id, 'number') }}</td>
                                            <td><a :href="getGuestParam(order.user.id, 'link')" target="_blank">{{ order.user.name }}</a></td>
                                            <td>
                                                <a v-if="order.link" :href="order.link" target="_blank"><span class="material-icons" style="font-size: 90%">open_in_new</span></a>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-else><em>no orders yet</em></div>
                            </div>
                        </div>

                        <span class="app-required"></span> This field will be displayed in the RESET Guest App.

                    </div>
                    <div class="modal-footer">
                        <div style="margin-right: auto" v-if="courseSchedule">
                            <a :href="courseSchedule.url" class="btn btn-info" v-if="courseSchedule.url" target="_blank">Open in new tab</a>
                            <button type="button" class="btn btn-info" @click="refresh()">Refresh</button>
                        </div>
                        <button type="button" class="btn btn-secondary" @click="hide()">Close</button>
                        <button type="button" class="btn btn-primary" @click="toEdit()" v-if="allow.edit">Edit</button>
                    </div>
                </div>
                <div v-if="viewType === 'edit' && allow.edit">
                    <div class="modal-body" v-if="courseScheduleForm">
                        <div class="row">
                            <div class="col-md-6">
                                <h5>Edit Course Schedule #{{ courseScheduleForm.id }}</h5>
                                <div class="row mb-3">
                                    <div class="col-md-4 label">Status</div>
                                    <div class="col-md-8">
                                        <select v-model="courseScheduleForm.is_active" class="form-select">
                                            <option value="0">not active</option>
                                            <option value="1">active</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-md-4 label app-required">Date</div>
                                    <div class="col-md-8">
                                        <input type="date" v-model="courseScheduleForm.date" class="form-control">
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-md-4 label app-required">Time</div>
                                    <div class="col-md-1 label">From</div>
                                    <div class="col-md-3">
                                        <input type="time" v-model="courseScheduleForm.time_from" class="form-control">
                                    </div>
                                    <div class="col-md-1 label">Till</div>
                                    <div class="col-md-3">
                                        <input type="time" v-model="courseScheduleForm.time_till" class="form-control">
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-md-4 label app-required">Class</div>
                                    <div class="col-md-8">
                                        <select class="form-select" v-model="courseScheduleForm.course_id" title="courses" @change="updateTrainer()">
                                            <option v-for="course in library.courses" :value="course.id">{{ course.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-md-4 label app-required">Trainer</div>
                                    <div class="col-md-8">
                                        <select class="form-select" v-model="courseScheduleForm.trainer_id" title="trainers">
                                            <option v-for="trainer in library.trainers" :value="trainer.id">{{ trainer.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-md-4 label">Level</div>
                                    <div class="col-md-8">
                                        <select class="form-select" v-model="courseScheduleForm.course_level_id" title="levels">
                                            <option v-for="level in library.levels" :value="level.id">{{ level.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-md-4 label">Capacity</div>
                                    <div class="col-md-8">
                                        <input type="number" v-model="courseScheduleForm.capacity" class="form-control">
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-md-4 label app-required">Location</div>
                                    <div class="col-md-8">
                                        <select class="form-select" v-model="courseScheduleForm.location_id" title="locations">
                                            <option v-for="location in library.locations" :value="location.id">{{ location.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-md-4 label">Location comment</div>
                                    <div class="col-md-8">
                                        <input type="text" v-model="courseScheduleForm.location_comment"
                                               class="form-control" maxlength="150">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6" v-if="courseSchedule">
                                <h5>Guests In Session</h5>
                                <p>Max {{ availability }} allowed</p>
                                <div class="table-responsive course-orders" style="max-height: 400px; overflow-y: auto">
                                    <table class="table table-reset">
                                        <thead>
                                        <tr>
                                            <th>booking</th>
                                            <th>path</th>
                                            <th>room</th>
                                            <th>name</th>
                                            <th></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="order in courseOrders" class="course-order">
                                            <td>{{  order.booking.name }}</td>
                                            <td>{{  order.path }}</td>
                                            <td>{{ getRoomParamForGuest(order.user.id, 'number') }}</td>
                                            <td>{{ order.user.name }}</td>
                                            <td><button class="btn btn-sm btn-danger" @click="cancelCourseOrder(order)">cancel</button></td>
                                        </tr>
                                        <tr v-for="bookingUser in getGuestsAllowedToAdd()" class="course-order">
                                            <td>{{  bookingUser.booking.name }}</td>
                                            <td>{{  bookingUser.path }}</td>
                                            <td>
                                                <span v-if="bookingUser.room">{{ bookingUser.room.number }}</span>
                                            </td>
                                            <td>{{ bookingUser.user.name }}</td>
                                            <td>
                                                <span v-if="isGuestAvailable(bookingUser.user)">
                                                    <button class="btn btn-sm btn-success" @click="order(bookingUser)">add</button>
                                                </span>
                                                <span v-else class="text-muted">busy</span>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <span class="app-required"></span> This field will be displayed in the RESET Guest App.

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="toShow()">Cancel</button>
                        <button type="button" class="btn btn-primary" @click="save()" :disabled="loading">Save changes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

const mixinDayJs = require('../../helpers/vue_mixins').mixinDayJs;
const mixinErrorHandler = require('../../helpers/vue_mixins').mixinErrorHandler;
import {Modal} from 'bootstrap'

export default {
    mixins: [mixinDayJs, mixinErrorHandler],
    props: {
        course_schedule: Object,
        library: Object,
        api_urls: Object,
        reset_session: Object,
        permissions: Object
    },
    data() {
        return {
            courseSchedule: null,
            modal: null,
            viewType: 'show',
            courseScheduleForm: null,
            loading: false,
            courseOrders: [],
            guestsAvailability: [],
            allow: {
                create: true,
                edit: true,
                show: true,
            }
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.loading = false;
            if (this.permissions) {
                _.merge(this.allow, this.permissions);
            }
            this.courseSchedule = this.course_schedule;
            this.getCourseOrders();
            if (!this.modal) {
                this.modal = new Modal(this.$refs.courseScheduleDetailModal);
            }
            if (!this.modal.visible) {
                this.modal.show();
            }
            this.toShow();
        },

        getCourseOrders() {
            const url = _.replace(this.$root.apiUrls.course_schedule.course_orders, 'COURSE_SCHEDULE_ID', this.courseSchedule.id);
            this.$root.api.get(url).then(response => {
                if (this.$root.checkNoError(response)) {
                    this.courseOrders = response.data;
                }
            }).catch(e => {
                this.$root.alertApiError(e, this.$root.api);
            });

            this.getGuestsAvailability();
        },

        order(bookingUser) {
            const url = _.replace(this.$root.apiUrls.course_schedule.order, 'COURSE_SCHEDULE_ID', this.courseSchedule.id);
            const params = {
                booking_user_id: bookingUser.id
            };
            this.$root.api.post(url, params).then(response => {
                if (this.$root.checkNoError(response)) {
                    this.courseOrders.push(response.data);
                    this.getCourseOrders();
                }
            }).catch(e => {
                this.$root.alertApiError(e, this.$root.api);
            });
        },

        getGuestsAllowedToAdd() {
            const data = _.filter(this.guests, (bu) => {
                if (_.find(this.courseOrders, (o) => {
                    return o.user.id === bu.user.id;
                })) {
                    return false;
                }
                return true;
            });

            return data;
        },

        isGuestAvailable(guest) {
            let data = _.find(this.guestsAvailability, (g) => {
                return g.id === guest.id;
            });

            if (_.isUndefined(data)) {
                return false;
            }

            return true;
        },

        getGuestsAvailability() {
            let url = _.replace(this.$root.apiUrls.course_schedule.availability, 'COURSE_SCHEDULE_ID', this.courseSchedule.id);
            url = _.replace(url, 'RESET_SESSION_ID', this.reset_session.id);
            this.$root.api.get(url).then(response => {
                if (this.$root.checkNoError(response)) {
                    this.guestsAvailability = response.data;
                }
            }).catch(e => {
                this.$root.alertApiError(e, this.$root.api);
            });
        },

        cancelCourseOrder(order) {
            if (confirm('You are going to cancel the order? Are you sure?')) {
                const url = _.replace(this.$root.apiUrls.course_order.cancel, 'COURSE_ORDER_ID', order.id);
                _.remove(this.courseOrders, {
                    id: order.id
                });
                this.$root.api.get(url).then(response => {
                    if (this.$root.checkNoError(response)) {
                        this.getCourseOrders();
                    }
                }).catch(e => {
                    this.$root.alertApiError(e, this.$root.api);
                });
            }
        },

        toEdit() {
            this.toFormData(this.courseSchedule);
            this.viewType = 'edit';
        },

        toShow() {
            this.viewType = 'show';
            this.courseScheduleForm = null;
        },

        toFormData(courseSchedule) {
            let form = {};
            form.id = courseSchedule.id;
            form.date = this.dateFormat(courseSchedule.from, 'YYYY-MM-DD');
            form.time_from = this.dateFormat(courseSchedule.from, 'HH:mm');
            form.time_till = this.dateFormat(courseSchedule.till, 'HH:mm');
            form.is_active = courseSchedule.is_active;
            if (courseSchedule.course) {
                form.course_id = courseSchedule.course.id;
            } else {
                form.course_id = null;
            }
            if (courseSchedule.trainer) {
                form.trainer_id = courseSchedule.trainer.id;
            } else {
                form.trainer_id = null;
            }
            if (courseSchedule.level) {
                form.course_level_id = courseSchedule.level.id;
            } else {
                form.course_level_id = null;
            }
            if (courseSchedule.location) {
                form.location_id = courseSchedule.location.id;
            } else {
                form.location_id = null;
            }
            form.location_comment = courseSchedule.location_comment;
            form.capacity = courseSchedule.capacity;
            this.courseScheduleForm = form;
        },

        updateTrainer() {
            const course = _(this.library.courses).find({ id: this.courseScheduleForm.course_id });
            if (course.trainer_id) {
                this.courseScheduleForm.trainer_id = course.trainer_id;
            }
        },

        hide() {
            this.modal.hide();
            this.$emit('closed', {course_schedule: this.courseSchedule});
        },

        refresh() {
            this.getCourseOrders();
            this.$emit('refresh', {course_schedule: this.courseSchedule});
            this.courseSchedule = null;
        },

        save() {
            this.loading = true;
            this.$emit('updated', {course_schedule: this.courseScheduleForm});
            this.viewType = null;
            this.courseSchedule = null;
        },

        sortedOrders: function(orders) {
            // return _.sortBy(orders, ['room.', 'age'])
            // this.items.sort( ( a, b) => {
            //     return new Date(a.date) - new Date(b.date);
            // });
            // return this.items;
        },

        getRoomParamForGuest: function(guestId, roomParam = null) {
            const bookingUser = _.find(this.guests, (el) => el.user.id === guestId);
            if (bookingUser) {
                if (roomParam) {
                    return bookingUser.room[roomParam];
                }

                return bookingUser.room;
            }
        },

        getGuestParam: function(guestId, param = null) {
            const bookingUser = _.find(this.guests, (el) => el.user.id === guestId);
            if (bookingUser) {
                if (param) {
                    return bookingUser.user[param];
                }

                return bookingUser.user;
            }
        },


    },

    watch: {
        course_schedule(newVal, oldVal) {
            this.init();
        }
    },
    computed: {
        guests: function() {
            if (this.library) {
                return this.library.guests;
            }

            return [];
        },

        availability: function() {
            return parseInt(this.courseSchedule.capacity) - this.courseOrders.length;
        },


    }
}
</script>
